<template>
<div class="hy-index" v-if="loading">
    <!--顶部导航-->
    <van-sticky>
      <div class="index-nav">
        <router-link class="nav-link active" to="/">首页</router-link>
        <router-link class="nav-link" to="/meeting" @click="hy_more_click(0)">会议</router-link>
        <router-link class="nav-link" to="/salon" @click="hy_more_click(1)">沙龙</router-link>
        <router-link class="nav-link" to="/activity" @click="hy_more_click(2)">活动</router-link>
      </div>
    </van-sticky>
    <!--banner-->
    <div class="index-bannerbox">
      <van-swipe class="my-swipe" :autoplay="5000">
        <van-swipe-item v-for="(item, index) in imagesList" :key="index">
          <img v-lazy="item.imgUrl" @click="goPath(item.path)" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="index-searchbox">
      <van-search
        v-model="searchValue"
        shape="round"
        background="#FFF"
        placeholder="输入关键字，搜索讲座"
        @search="onSearch"
      />
    </div>
    <!--列表-->
    <div class="index-list"  v-if="tuiList.length > 0">
      <div class="rows">
        <h5 class="index-title">
          近期重要活动
          <router-link class="more-link" to="/future">
            更多
            <span class="iconfont">&#xe6ce;</span>
          </router-link>
        </h5>
        <van-list :finished="finished" >
          <van-cell v-for="item in tuiList" :key="item.id">
            <a class="more-link" @click="hy_more_click(3,'/index/conference/template?id='+item.gid)">
              <div class="imgbox">
                <img :src="item.spread.cover_url" alt />
                <span class="text_icon" v-if="item.spread.status_str == '待发布'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_yellow" v-if="item.spread.status_str == '已发布' || item.spread.status_str == '报名中'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.spread.status_str == '会议中'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="item.spread.status_str == '已结束'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="item.spread.status_str == '未到报名时间'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="item.spread.status_str == '报名截止'">{{item.spread.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{item.spread.status_str}}</span>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{item.spread.name}}</h5>
                  <span class="type"  v-if="item.spread.type== 1">会议</span>
                  <span class="type"  v-else-if="item.spread.type== 2">沙龙</span>
                  <span class="type"  v-if="item.spread.type== 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{item.spread.start_time,'Y-M-D'|formatDates}}~{{item.spread.end_time,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{item.spread.region}}&nbsp;{{item.spread.specific_address}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
      </div>
    </div>
    <div class="index-list">
      <div class="rows">
        <h5 class="index-title">全部活动</h5>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell v-for="items in data" :key="items.id"   v-if="data.length > 0" >
            <a class="more-link"  @click="hy_more_click(3,'/index/conference/template?id='+items.id)" >
              <div class="imgbox">
                <img :src="items.cover_url" alt />
                <span class="text_icon icon_yellow" v-if="items.status_str == '已发布' || items.status_str == '报名中'">{{items.status_str }}</span>
                <span class="text_icon icon_blue" v-else-if="items.status_str == '会议中'">{{items.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="items.status_str == '已结束' || items.status_str == '暂停报名' || items.status_str == '暂停报名'">{{items.status_str }}</span>
                <span class="text_icon icon_yellow" v-else-if="items.status_str == '未到报名时间'">{{items.status_str }}</span>
                <span class="text_icon icon_black" v-else-if="items.status_str == '报名截止'">{{items.status_str }}</span>
                <span class="text_icon icon_black" v-else>{{items.status_str }}</span>
              </div>
              <div class="textbox">
                <div class="title">
                  <h5>{{items.name}}</h5>
                  <span class="type"  v-if="items.type== 1">会议</span>
                  <span class="type"  v-else-if="items.type== 2">沙龙</span>
                  <span class="type"  v-if="items.type== 3">活动</span>
                  <!-- <span class="type">活动</span> -->
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe67f;</span>
                  {{items.start_time ,'Y-M-D'|formatDates}}~ {{items.end_time ,'Y-M-D'|formatDates}}
                </div>
                <div class="textinfo">
                  <span class="iconfont">&#xe64d;</span>
                  {{items.region}}&nbsp;{{items.specific_address}}
                </div>
              </div>
            </a>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <router-link class="iconfont fixed-link" to="/myEnroll">&#xe609;</router-link>
    </div>
  </div>
</template>


<script>
import { formatDates } from "../assets/js/date";
export default {
  data() {
    return {

      imagesList: [],
      bannerdata:[],
      searchValue: "",
      /* 全部会议 */
      data: [],
      /* 近期会议 */
      tuiList: [],
       /*暂存全部会议数据 */
      allList: [],
      loading: false,
      finished: false,
      page: 0,
      pagesize: 5,
      total: 0 //总条数
    };
  },
  created() {
    var _this = this;
    /*this.list(this.page, this.pagesize);
    _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:''});*/
    window.location.replace("/conference/index");
  },
  /* 时间过滤 */
  filters: {
    formatDates
  },
  methods: {
    hy_more_click(index,path){
      if(index == '0'){
        _trackData.push(['addaction', '会议服务', '会议首页_MAP','导航切换_会议']);
      }
      if(index == '1'){
        _trackData.push(['addaction', '会议服务', '会议首页_MAP','导航切换_沙龙']);
      }
      if(index == '2'){
        _trackData.push(['addaction', '会议服务', '会议首页_MAP','导航切换_活动']);
      }
      if(index == '3'){
        _trackData.push(['addaction', '会议服务', '会议首页_MAP','会议、沙龙查看详情']);
        setTimeout(function(){
          window.location.href = path;
        },200)
      }
      if(index == '4'){
        _trackData.push(['addaction', '会议服务', '会议首页_MAP','搜索']);
      }
    },
    //banner跳转方法
    goPath(path) {
      if (path == "") {
        return false;
      }
     // this.$router.push(path);
      window.location.href = path;
    },
    //搜索方法
    onSearch(val) {
      if (val != "") {
        this.hy_more_click(4);
        this.$router.push({
          path: `/search/${val}`
        });
      }else{
       this.$toast('请输入搜索内容');
      }
    },
    //热门咨询加载
    onLoad() {
      setTimeout(() => {
        var _this = this;
        _this.page++;
        let url = "/ac1/conference/index";
        let params = {
          page: _this.page,
          pagesize: _this.pagesize
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            if(res.posts.conference.list.length  == 0){
              _this.finished = true;
              return false;
            }
            _this.allList = res.posts.conference.list;
            _this.total = res.posts.conference.count;
            _this.allList.forEach(v => {
              _this.data.push(v);
            });
            if(res.posts.banner.length != 0){
             _this.bannerdata =  res.posts.banner;
             var bannerL= [];
             _this.bannerdata.data.forEach(v => {
               bannerL.push(
                 {
                   imgUrl: v.pic_url,
                   path: v.url,
                   id:v.item_id
                 }
               );
             });
           }
            _this.imagesList = bannerL;
            // 加载状态结束
            _this.loading = false;
            // 数据全部加载完成
            if (_this.data.length >= _this.total) {
              _this.finished = true;
            }
          }
        });

      }, 500);
    },
    /* 初始化数据列表 */
    list(page, pagesize) {
      var _this = this;
      let url = "/ac1/conference/index";
      let params = {
        page: 1,
        pagesize: 2
      };
      _this.$get(url, params).then(res => {
        if (res.code == "1") {
          for(var i=0 ;i<2;i++){
            if(res.posts.recommended[i] != undefined){
              _this.tuiList.push(res.posts.recommended[i]);
            }
          }
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>
